var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 56C46.4852 56 40.3537 54.5481 34.1056 51.6444C27.8574 48.7407 22.063 44.6185 16.7222 39.2778C11.3815 33.937 7.25926 28.1426 4.35556 21.8944C1.45185 15.6463 0 9.51482 0 3.5C0 2.51481 0.337037 1.68519 1.01111 1.01111C1.68519 0.337037 2.51481 0 3.5 0H14.3889C15.1148 0 15.737 0.259259 16.2556 0.777778C16.7741 1.2963 17.137 1.94444 17.3444 2.72222L19.4444 12.5222C19.5481 13.2481 19.5352 13.9093 19.4056 14.5056C19.2759 15.1019 19.0037 15.6074 18.5889 16.0222L10.8111 23.8778C12.1593 26.1593 13.5852 28.2852 15.0889 30.2556C16.5926 32.2259 18.2519 34.0926 20.0667 35.8556C21.9852 37.8259 24.0074 39.6278 26.1333 41.2611C28.2593 42.8944 30.4889 44.3333 32.8222 45.5778L40.2111 37.9556C40.7296 37.3852 41.3259 36.9963 42 36.7889C42.6741 36.5815 43.3482 36.5296 44.0222 36.6333L53.2778 38.6556C54.0556 38.863 54.7037 39.2778 55.2222 39.9C55.7407 40.5222 56 41.2222 56 42V52.5C56 53.4852 55.663 54.3148 54.9889 54.9889C54.3148 55.663 53.4852 56 52.5 56Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallInProgress);
export default __webpack_public_path__ + "static/media/CallInProgress.a53294cea425674eb27da20a475bccda.svg";
export { ForwardRef as ReactComponent };